import { useSelector } from 'react-redux'

import {
  selectActiveSources,
  selectShouldFetchSourceSchema,
  selectSourcesFetched,
  selectSimTable
} from 'redux/selectors/SimTables'

/**
 * Hook for active sim table
 */
export const useSimTable = () => {
  return useSelector(selectSimTable)
}

export const useShouldFetchSourceSchema = () => {
  return useSelector(selectShouldFetchSourceSchema)
}

export const useSourcesFetched = () => {
  return useSelector(selectSourcesFetched)
}

export const useSourceSchemas = () => {
  return useSelector(selectActiveSources)
}
